var navLinks = document.querySelectorAll('.cus_support_nav_links a'); // Replace with the actual class or ID of your navigation menu
navLinks.forEach(function(link) {
  if (link.hostname !== window.location.hostname) {
    link.target = '_blank';
    link.rel = 'noreferrer noopener';
  }
});

let modalsElement = document.querySelectorAll('[data-wau-modal-content]');
if (modalsElement.length > 0) {
  modalsElement.forEach(modal => {
    WAU.Modal.init(modal.dataset.wauModalContent);
  });
} 
if (document.querySelector('.top-product-tabs') != undefined) {
  productTabsResize()
  window.addEventListener('resize', function(event) {
    productTabsResize()
  }, true);
} 
function productTabsResize(){
  if ( WAU.Helpers.isDevice() ) {
    document.querySelector('.top-product-tabs').style.display = "block";;
  } else {
    let tabElement = document.querySelector('.top-product-tabs');
    document.querySelector('.product-block--variants').after(tabElement);
  }
}
// Replace with your actual Shopify-hosted CSV URL
const csvUrl = 'https://cdn.shopify.com/s/files/1/1667/4225/files/costcalculator.csv?v=1745946843';
/*(20) ['Ingredient,Milk or Creamer,"Organic or Conventional","Store-Bought ', 'Price/8oz","Homemade', 'Price/8oz",Weekly Savings,Monthly Savings,Yearly Savings\r', 'Almond,Milk,Conventional,$1.08,$0.51,$4.16,$18.07,$216.83\r', 'Almond,Milk,Organic,$0.86,$0.51,$2.55,$11.10,$133.17\r', 'Almond,Creamer,Conventional,$1.52,$1.51,$0.54,$2.33,$27.93\r', 'Almond,Creamer,Organic,$1.51,$1.51,$0.48,$2.06,$24.78\r', 'Cashew,Milk,Conventional,$1.34,$0.58,$5.46,$23.73,$284.76\r', 'Cashew,Milk,Organic,$2.23,$0.58,$11.96,$51.98,$623.80\r', 'Cashew,Creamer,Conventional,$2.83,$1.65,$8.54,$37.11,$445.33\r', 'Cashew,Creamer,Organic,$2.23,$1.65,$11.96,$51.98,$623.80\r', 'Oats,Milk,Conventional,$0.61,$0.40,$1.53,$6.63,$79.53\r', 'Oats,Milk,Organic,$1.46,$0.40,$7.68,$33.37,$400.47\r', 'Oats,Creamer,Conventional,$1.25,$1.13,$0.88,$3.82,$45.80\r', 'Oats,Creamer,Organic,$1.39,$1.13,$1.94,$8.44,$101.27\r', 'Coconut,Milk,Conventional,$0.95,$0.24,$5.18,$22.52,$270.30\r', 'Coconut,Milk,Organic,$0.90,$0.24,$4.77,$20.72,$248.67\r', 'Coconut,Creamer,Conventional,$1.29,$0.68,$4.40,$19.11,$229.31\r', 'Coconut,Creamer,Organic,$1.57,$0.68,$6.48,$28.16,$337.89'] */
// Helper function to load and parse CSV
async function loadCSV(url) {
  const response = await fetch(url);
  const text = await response.text();
  
  const rows = text.trim().split('\n');
  const headers = rows[0].split(',').map(h => h.trim());
console.log(rows);
  return rows.slice(1).map(row => {
    const values = row.split(',').map(v => v.trim());
    return headers.reduce((obj, header, idx) => {
      obj[header] = values[idx];
      return obj;
    }, {});
  });
}
// Global variable to hold the CSV data
let csvData = [];

// Initialize
(async function() {
  csvData = await loadCSV(csvUrl);
})();

// Attach event listeners
document.querySelectorAll(".select-your-grain button").forEach(p => p.addEventListener('click', onGrainSelection));

function onGrainSelection(e) {
  document.querySelectorAll(".select-your-grain").forEach(p => p.classList.remove('active'));
  e.target.closest(".select-your-grain").classList.toggle("active");
  calculateData();
}

document.querySelectorAll(".pick-your-category button").forEach(p => p.addEventListener('click', onPickCategorySelection));

function onPickCategorySelection(e) {
  document.querySelectorAll(".pick-your-category").forEach(p => p.classList.remove('active'));
  e.target.closest(".pick-your-category").classList.toggle("active");
  calculateData();
}

document.querySelectorAll(".choose-your-type button").forEach(p => p.addEventListener('click', onChooseTypeSelection));

function onChooseTypeSelection(e) {
  document.querySelectorAll(".choose-your-type").forEach(p => p.classList.remove('active'));
  e.target.closest(".choose-your-type").classList.toggle("active");
  calculateData();
}

function calculateData(){
  //calculate based on selection
  const nutGrain = document.querySelector('.select-your-grain.active p').textContent;
  const category = document.querySelector('.pick-your-category.active p').textContent;
  const type = document.querySelector('.choose-your-type.active p').textContent;
  csvData.find(row => 
    {
      //"Ingredient,milk creamer,Organic Conventional,Store-Bought,Homemade,Weekly Savings,Monthly Savings,Yearly Savings"
      if(row['Ingredient'] === nutGrain &&
      row['milk creamer'] === category &&
      row['Organic Conventional'] === type){
        document.querySelector('.storebought p').innerHTML = row['Store-Bought'];
        document.querySelector('.homemade p').innerHTML = row['Homemade'];
        document.querySelector('.weekly-price p').innerHTML = row['Weekly Savings'];
        document.querySelector('.monthly-price p').innerHTML = row['Monthly Savings'];
        document.querySelector('.yearly-price p').innerHTML = row['Yearly Savings'];
      }
    }
  );
}